<template>
  <tfoot class="table-footer">
    <tr class="footer-row">
      <td
        :colspan="titleColspan"
        class="footer-cell cell-title"
      >
        <span>{{ title }}</span>
      </td>
      <td
        v-for="(column, index) in footerColumns"
        :key="index"
        :class="[`has-text-${column.align || 'left'}`]"
        class="footer-cell"
      >
        <span
          v-if="column.footer"
          :class="[
            column.staticClass,
            column.conditionalClass &&
              column.conditionalClass(getFooterValue(column.name), footerData),
          ]"
        >{{ formattedCellValue(column.name) }}</span>
      </td>
    </tr>
  </tfoot>
</template>

<script>

export default {
  name: 'TableFooter',
  props: {
    columns: { type: Array, default: () => [] },
    footerData: { type: Object, default: () => {} },
    title: { type: String, default: null },
    titleColspan: { type: Number, default: 1 },
  },
  computed: {
    footerColumns() {
      return this.columns.filter((item, index) => index >= this.titleColspan && !item.hideColumn);
    },
  },
  methods: {
    getFooterValue(columnName) {
      return (this.footerData[columnName]);
    },
    formattedCellValue(columnName) {
      const cellValue = this.footerData[columnName];
      const column = this.footerColumns.find(item => item.name === columnName);
      if (Number.isNaN(cellValue) || !column) return ' ';
      switch (column.type) {
        case 'currency':
          return this.$filters.currency(cellValue);
        case 'quantity':
          return this.$filters.quantity(cellValue);
        default:
          return cellValue;
      }
    },
  },
};
</script>

<style lang="scss">

.table-footer {
  .footer-row {
    background-color: transparent;
    td:first-child {
      padding-left:1rem;
    }

    td:last-child {
      padding-right:1rem;
    }
  }
  .footer-row .footer-cell{
    font-size: $size-10;
    font-weight: $weight-bold;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .footer-row {
    &:last-child td {
      background-color: $white;
    }
    &:last-child td:first-child {
      border-bottom-left-radius: 0.62rem;
      }
    &:last-child td:last-child {
      border-bottom-right-radius: 0.62rem;
    }
  }

  .footer-row .cell-title {
    color: $blue-steel;
  }
}

</style>
